import type { BalanceSummary } from '@entities/wallet'
import type { BalanceItem, MoneyDto } from '../api/admin.api'

const walletMoney = (value: MoneyDto): BalanceSummary['available'] => ({
  amount: value.amount,
  currency: value.currency as BalanceSummary['currency'],
})

export function adminBalanceAsSummary(item: BalanceItem): BalanceSummary {
  return {
    currency: item.currency as BalanceSummary['currency'],
    available: walletMoney(item.available),
    pending: walletMoney(item.pending),
    ...(item.awaitingAvailability
      ? { awaitingAvailability: walletMoney(item.awaitingAvailability) }
      : {}),
    reserve: walletMoney(item.reserve),
    openDebt: walletMoney(item.openDebt),
    processingWithdrawal: walletMoney(item.processingWithdrawal),
    processingDebtRecovery: walletMoney(item.processingDebtRecovery),
    nextReleases: (item.nextReleases ?? []).map((release) => ({
      ...release,
      amount: walletMoney(release.amount),
    })),
  }
}
